import React, { useState, useEffect } from "react";
import useLanguageDirection from "../../hooks/useLanguageDirection";

const CustomBuyForMeButton = ({ children, onClick, icon: Icon }) => {

  const [isDisabled, setIsDisabled] = useState(false);
  const direction = useLanguageDirection();
  
  const handleClick = () => {
    if (isDisabled) return;

    setIsDisabled(true);
    onClick();

    setTimeout(() => {
      setIsDisabled(false);
    }, 500000); // 3 ثواني
  };

  return (
    <div className="flex items-center justify-center my-8" dir={direction}>
      <button
        onClick={handleClick}
        disabled={isDisabled}
        className={`inline-flex items-center justify-center px-6 py-3 text-base font-normal text-black transition duration-300 ease-in-out transform lg:font-medium bg-custom-yellow rounded-custom sm:text-sm md:text-lg lg:text-base ${
          isDisabled ? "opacity-50 cursor-not-allowed" : "hover:scale-105"
        } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color whitespace-nowrap`}
      >
        {children}
        {Icon && (
          <Icon
            className={`w-4 ms-2 text-black ${direction === "ltr" ? "rotate-180" : ""}`}
          />
        )}
      </button>
    </div>
  );
};

export default CustomBuyForMeButton;
